import { langTypes } from 'config/langType';

export default function getNavigatorLangForAdmin() {
    return navigator.language.toLowerCase() === 'zh-tw' ? langTypes.ZH_TW : langTypes.EN_US;
}
